import { ReactElement } from 'react';
import { Toaster } from 'react-hot-toast';

export const MyToaster = (): ReactElement => {
  return <Toaster position="bottom-center" />;
};
